"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { useElements } from '../useElements.mjs';

function useAppDataSchemas(query) {
  const { ...rest } = useElements("app-data-schemas", query);
  return {
    appDataSchemas: rest.items,
    ...rest
  };
}

export { useAppDataSchemas };
